import { FC } from "react"

import { ReactComponent as IconList } from "@common_assets/svg/grid-horizontal.svg"
import { ReactComponent as IconGrid } from "@common_assets/svg/grid-outlined.svg"
import { Box, Stack } from "@mui/material"
import { useAppDispatch, useAppSelector } from "hooks/store"
import mixpanel from "mixpanel-browser"
import { useTranslation } from "react-i18next"
import { selectDisplayMode } from "store/displayMode/displayMode.selectors"
import { setDisplayMode } from "store/displayMode/displayMode.slice"
import {
  setClassList,
  setIsNextPage,
  setPage,
} from "store/utility/utility.slice"

const ListingDisplayModeButtons: FC = () => {
  const dispatch = useAppDispatch()
  const displayMode = useAppSelector(selectDisplayMode)
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      boxShadow={(theme) =>
        `inset 0px 0px 0px 1px ${theme.palette.primary.main}`
      }
      borderRadius="16px"
      gap="8px"
      p="12px"
      alignItems="center"
      width="max-content"
    >
      <Box
        component="button"
        type="button"
        width="32px"
        height="32px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        aria-label={t("students.gridView")}
        aria-pressed={displayMode === "grid"}
        sx={{
          cursor: "pointer",
          transition: "color .5s, background-color .5s",
          color: displayMode === "grid" ? "primary.main" : "mockup.neutral40",
          border: (theme) =>
            displayMode === "grid"
              ? `1px solid ${theme.palette.primary.main}`
              : "1px solid transparent",
          borderRadius: "8px",
          padding: 0,
          margin: 0,
          fontFamily: "inherit",
          "&:hover": {
            color: "mockup.primary80",
          },
        }}
        onClick={() => {
          if (displayMode === "grid") return
          dispatch(setDisplayMode("grid"))
          dispatch(setClassList([]))
          dispatch(setPage(0))
          dispatch(setIsNextPage(true))
          mixpanel.track("change_page_view", {
            event_name: "grid",
          })
        }}
      >
        <IconGrid />
      </Box>
      <Box height="17px" width="2px" bgcolor="mockup.primary95" />
      <Box
        component="button"
        type="button"
        width="32px"
        height="32px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        aria-label={t("students.listView")}
        aria-pressed={displayMode === "list"}
        sx={{
          cursor: "pointer",
          transition: "color .5s, background-color .5s",
          color: displayMode === "list" ? "primary.main" : "mockup.neutral40",
          border: (theme) =>
            displayMode === "list"
              ? `1px solid ${theme.palette.primary.main}`
              : "1px solid transparent",
          borderRadius: "8px",
          padding: 0,
          margin: 0,
          fontFamily: "inherit",
          "&:hover": {
            color: "mockup.primary80",
          },
        }}
        onClick={() => {
          if (displayMode === "list") return
          dispatch(setDisplayMode("list"))
          dispatch(setClassList([]))
          dispatch(setPage(0))
          dispatch(setIsNextPage(true))
          mixpanel.track("change_page_view", {
            event_name: "table",
          })
        }}
      >
        <IconList />
      </Box>
    </Stack>
  )
}

export default ListingDisplayModeButtons
